export default __webpack_public_path__ + "static/media/image-placeholder-square.709ff424.svg";